import React, { useState } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import MenuIcon from '@material-ui/icons/Menu'
import { Link, Switch, Route } from 'react-router-dom'
import ActiveNowMobile from '../ActiveNow/ActiveNowMobile'
import { logoutUser } from '../Store/actions'

const HeaderMobile = props => {
  const [isMenuVisible, setIsMenuVisible] = useState(false)

  return (
    <div style={{ width: '100vw' }}>
      <img
        src={require('../assets/logo-02.svg')}
        alt="logo"
        style={{
          width: '125px',
          height: '75px',
          position: 'absolute',
          top: '-23px',
          left: '-30px'
        }}
      />

      <header>
        <div
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
            backgroundColor: '#F6F9FD'
          }}
        >
          <div
            onClick={() => setIsMenuVisible(!isMenuVisible)}
            style={isMenuVisible ? { backgroundColor: ' #B8D5FC' } : null}
          >
            <MenuIcon style={{ width: '24px', padding: '5px' }} />
          </div>
        </div>
      </header>
      {isMenuVisible && (
        <div
          style={{ position: 'absolute', backgroundColor: 'white', width: '100%', height: '100%' }}
        >
          <div style={{ padding: '20px 0 10px 0' }}>
            <span style={{ color: '#6B6C70', fontSize: '16px', paddingLeft: '16px' }}>
              HaulR Portal
            </span>
          </div>
          {[
            { path: 'active', name: 'Active Now' }
            // { path: 'projects', name: 'Projects' },
            // { path: 'hauls', name: 'Hauls' },
            // { path: 'contacts', name: 'Contacts' },
            // { path: 'sites', name: 'Sites' }
          ].map((item, i) => (
            <Link
              key={i}
              to={`/app/${item.path}`}
              style={{ textDecoration: 'none' }}
              onClick={() => setIsMenuVisible(false)}
            >
              <div
                style={{
                  height: '44px',
                  display: 'flex',
                  alignItems: 'center',
                  width: '188px',
                  backgroundColor: props.activeTab === item.path ? '#B8D5FC' : null
                }}
              >
                <span
                  style={{
                    fontSize: '24px',
                    color: props.activeTab === item.path ? '#F6F9FD' : '#3E3F42',
                    paddingLeft: '16px'
                  }}
                >
                  {item.name}
                </span>
              </div>
            </Link>
          ))}

          <div style={{ padding: '40px 0 10px 0' }}>
            <span style={{ color: '#6B6C70', fontSize: '16px', paddingLeft: '16px' }}>
              {props.userData.firstName} {props.userData.lastName}
            </span>
          </div>
          {/* <div style={{ height: '44px', display: 'flex', alignItems: 'center' }}>
            <span style={{ fontSize: '24px', color: '#3E3F42', paddingLeft: '16px' }}>
              View Profile
            </span>
          </div> */}
          <div
            style={{ height: '44px', display: 'flex', alignItems: 'center' }}
            onClick={props.logoutUser}
          >
            <span style={{ fontSize: '24px', color: '#3E3F42', paddingLeft: '16px' }}>
              Sign Out
            </span>
          </div>
        </div>
      )}
      <Switch>
        <Route path="/app/active" render={routeProps => <ActiveNowMobile {...routeProps} />} />
      </Switch>
      {props.children}
    </div>
  )
}

const mapStateToProps = state => {
  return {
    activeNow: state.activeNow,
    userData: state.user.userData
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({ logoutUser }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(HeaderMobile)
